/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'

/* COMPONENTS */

/* STORE */
import { setIsPopoverChatOpen } from '../../../../store/general/actions'

/* STYLES */
import {
  ItemImageWrapper,
  ItemImage,
  Title,
  AccomodationDetailsWrapper,
  CardIconsWrapper,
  CardIcon,
  CardIconText,
  GridItemWrapper,
  GridItemDetailsWrapper,
  AccomodationInfoWrapper,
  AccomodationInfo,
  DescriptionWrapper,
  Description,
  AccomodationPriceWrapper,
  AccomodationPrice,
  AccomodationPricePerPerson,
  MoreInfoWrapper,
  MoreInfoLink,
} from './style'

/* UTILS/CONSTANTS*/
import {
  CLOUDFRONT_BASE_URL,
  CLIENT_STYLINGS,
} from '../../../../utils/constants'
import { Analytics } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`

const AccomodationItem = ({
  index,
  isLessThanLaptop,
  item,
  router,
  language,
  setIsPopoverChatOpen,
  key,
  openPopoverChatOnClickthrough,
  randomMatch,
  itemsPerRow,
  organizationSlug,
  organizationDetails,
  slug,
  token,
}) => {
  const {
    name,
    images,
    price,
    destinations,
    label_image,
    label_card,
    description,
  } = item

  const [tripPrice, setAccomodationPrice] = useState(price)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  useEffect(() => {
    // SET TRIP PRICE
    if (item?.trip_info?.length) {
      for (let info of item.trip_info) {
        if (info?.selling_price) {
          // SET PRICE IF NOT SET
          setAccomodationPrice(info.selling_price)

          break
        }
      }
    }
  }, [key])

  const getUrlWithSlugAndToken = url => {
    if (slug && token) {
      // ADD SLUG AND TOKEN TO URL QUERY PARAMS
      // THIS HELPS TO CONTINUE CHATS IF USER VISITS OTHER BRANDS WEBSITES
      const urlObj = new URL(url)
      urlObj.searchParams.set('slug', slug)
      urlObj.searchParams.set('token', token)
      return urlObj.toString()
    }
    return url
  }

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper itemsPerRow={itemsPerRow}>
      <GridItemDetailsWrapper id='grid-item-details-wrapper'>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage
            target={
              organizationDetails?.openNewTabOnClickthroughGrid
                ? '_blank'
                : '_self'
            }
            href={getUrlWithSlugAndToken(item.url)}
            index={index}
            backgroundImage={itemImage}
            onClick={() => {
              Analytics.getInstance().sendEvent('maya_click_grid_item', {
                item_entity: 'trips',
                item_title: name,
                item_subtitle: tripPrice,
                item_type: label_image,
                item_destination: destinations[0],
                item_url: item.url,
              })
              logAction({
                name: 'url_click_grid',
                url: getUrlWithSlugAndToken(item.url),
                linkLabel: name,
              })
              if (openPopoverChatOnClickthrough) {
                setIsPopoverChatOpen(true)
              }
            }}
          ></ItemImage>
        </ItemImageWrapper>
        <AccomodationDetailsWrapper>
          {name ? (
            <Title
              href={getUrlWithSlugAndToken(item.url)}
              onClick={() => {
                Analytics.getInstance().sendEvent('maya_click_grid_item', {
                  item_entity: 'trips',
                  item_title: name,
                  item_subtitle: tripPrice,
                  item_type: label_image,
                  item_destination: destinations[0],
                  item_url: item.url,
                })
                logAction({
                  name: 'url_click_grid',
                  url: getUrlWithSlugAndToken(item.url),
                  linkLabel: name,
                })
                if (openPopoverChatOnClickthrough) {
                  setIsPopoverChatOpen(true)
                }
              }}
            >
              {name}
            </Title>
          ) : null}
          <CardIconsWrapper>
            {destinations?.length ? (
              <CardIcon>
                {' '}
                <i
                  class='fa-regular fa-location-dot fa-fw'
                  style={{
                    marginRight: '3px',
                    lineHeight: '1.2',
                    fontWeight: 700,
                    fontSize: '14px',
                    color:
                      CLIENT_STYLINGS[organizationSlug].COLOR.PRIMARY,
                  }}
                ></i>
                <CardIconText>{destinations[0]}</CardIconText>
              </CardIcon>
            ) : null}
            {label_card ? (
              <CardIcon
                style={{
                  borderLeft: `${
                    destinations?.length
                      ? `1px solid ${CLIENT_STYLINGS[organizationSlug].COLOR.BORDER}`
                      : '0px'
                  } `,
                }}
              >
                {' '}
                <i
                  class='fa-regular fa-people-group fa-fw'
                  style={{
                    marginRight: '3px',
                    lineHeight: '1.2',
                    fontWeight: 700,
                    fontSize: '14px',
                    color:
                      CLIENT_STYLINGS[organizationSlug].COLOR.PRIMARY,
                  }}
                ></i>
                <CardIconText>{label_card}</CardIconText>
              </CardIcon>
            ) : null}
          </CardIconsWrapper>
          {description ? (
            <DescriptionWrapper>
              <Description>
                {description.charAt(0).toUpperCase() + description.slice(1)}
              </Description>
            </DescriptionWrapper>
          ) : null}
          <MoreInfoWrapper>
            <MoreInfoLink
              href={getUrlWithSlugAndToken(item.url)}
              onClick={() => {
                Analytics.getInstance().sendEvent('maya_click_grid_item', {
                  item_entity: 'trips',
                  item_title: name,
                  item_subtitle: tripPrice,
                  item_type: label_image,
                  item_destination: destinations[0],
                  item_url: item.url,
                })
                logAction({
                  name: 'url_click_grid',
                  url: getUrlWithSlugAndToken(item.url),
                  linkLabel:
                    language === 'fr'
                      ? 'En savoir plus'
                      : language === 'de'
                      ? 'Mehr info'
                      : 'Meer info',
                })
                if (openPopoverChatOnClickthrough) {
                  setIsPopoverChatOpen(true)
                }
              }}
            >
              {language === 'fr'
                ? 'En savoir plus'
                : language === 'de'
                ? 'Mehr info'
                : 'Meer info'}
            </MoreInfoLink>
          </MoreInfoWrapper>
        </AccomodationDetailsWrapper>
        <AccomodationInfoWrapper>
          <AccomodationInfo>{label_image}</AccomodationInfo>
          {tripPrice ? (
            <AccomodationPriceWrapper>
              <AccomodationPrice>{tripPrice}</AccomodationPrice>
              <AccomodationPricePerPerson>
                {language === 'fr'
                  ? 'par personne'
                  : language === 'de'
                  ? 'pro Person'
                  : 'per persoon'}{' '}
              </AccomodationPricePerPerson>
            </AccomodationPriceWrapper>
          ) : null}
        </AccomodationInfoWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  openPopoverChatOnClickthrough: state?.general?.openPopoverChatOnClickthrough,
  organizationDetails: state?.maya?.organizationDetails,
  slug: state?.maya?.slug,
  token: state?.maya?.token,
})

const mapDispatchToProps = dispatch => ({
  setIsPopoverChatOpen: isOpen => dispatch(setIsPopoverChatOpen(isOpen)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AccomodationItem)
